import classNames from 'classnames';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateVideoPlayerBucketId } from 'actions/videoPlayer';
import { selectCommentBuckets } from 'selectors/comments';

import { useScrollToCallbackRef } from 'hooks/useScrollToCallbackRef';

import Comment from './comment';

import styles from './styles.module.less';

export function useScrollToCommentBucketRef({
  currentBucketInd,
  scrollContainer,
}) {
  const dispatch = useDispatch();
  const videoPlayer = useSelector(state => state.video_player);
  const commentBuckets = useSelector(selectCommentBuckets);
  const scrollToCommentBucketIndex = videoPlayer.scroll_to_bucket;
  const willHighlight = Object.keys(commentBuckets).length > 1;
  const scrollToThisGroup = scrollToCommentBucketIndex == currentBucketInd;
  const cleanup = useCallback(
    node => {
      if (willHighlight) {
        // we're going to keep scrolling on re-renders unless we clear this out
        node.addEventListener('animationend', () => {
          dispatch(updateVideoPlayerBucketId(null));
        });
      } else {
        dispatch(updateVideoPlayerBucketId(null));
      }
    },
    [dispatch, willHighlight]
  );

  const scrollToCommentBucketRef = useScrollToCallbackRef(
    scrollToThisGroup,
    scrollContainer,
    cleanup
  );

  return scrollToCommentBucketRef;
}

export const CommentGroup = ({
  drawnOnSharePage,
  bucket,
  bucketInd,
  scrollToCommentBucketIndex,
  scrollContainer,
  willHighlight,
}) => {
  const scrollToThisGroup = scrollToCommentBucketIndex == bucketInd;
  const highlightThisGroup = scrollToThisGroup && willHighlight;
  const highlightStyle = drawnOnSharePage
    ? styles.highlightDark
    : styles.highlight;

  const scrollRef = useScrollToCommentBucketRef({
    currentBucketInd: bucketInd,
    scrollContainer,
  });

  return (
    <div
      ref={scrollRef}
      className={classNames({
        [styles.commentGroup]: true,
        [highlightStyle]: highlightThisGroup,
      })}
    >
      {bucket.comments.map(comment => {
        return (
          <Comment
            drawnOnSharePage={drawnOnSharePage}
            key={comment.id}
            comment={comment}
            scrollContainer={scrollContainer}
            highlightStyle={highlightStyle}
          />
        );
      })}
    </div>
  );
};
